import { requestService as api } from "../Request.service"

const API_URL = {
  API_MANAGE: `/ERP/packing-list/manage.php`,
  API_SEARCH: `/ERP/packing-list/search.php`,
  API_GETCODE: `/ERP/packing-list/get-pkcode.php`,
  API_PREFILL_DEL: `/ERP/packing-list/prefill-del.php`,
  API_AVAILABLE_DEL: `/ERP/packing-list/available-delivery.php`,
};

const PackingListService = () => {

  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const code = () => api.get(`${API_URL.API_GETCODE}`);
  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });

  /* ดึงข้อมูลตั้งต้นจากใบส่งมอบ */
  const prefillFromDelivery = (delcode) => api.get(`${API_URL.API_PREFILL_DEL}?code=${delcode}`);

  /* รายการใบส่งมอบที่ยังไม่ได้สร้าง Packing List (all=1 = แสดงทั้งหมด) */
  const availableDelivery = (parm = {}) => {
    const query = new URLSearchParams();
    if (parm.keyword) query.set("keyword", parm.keyword);
    if (parm.all) query.set("all", "1");
    const qs = query.toString();
    return api.get(`${API_URL.API_AVAILABLE_DEL}${qs ? `?${qs}` : ""}`);
  };

  return {
    create,
    update,
    deleted,
    get,
    code,
    search,
    prefillFromDelivery,
    availableDelivery,
  };
};

export default PackingListService;
